// extracted by mini-css-extract-plugin
export default {"container":"fFB_dU4jG7YdS1mLs4gU"};